import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  width: "24",
  height: "24",
  transform: "translate(0.5)"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M3.5 18.7622V5C3.5 4.44772 3.94772 4 4.5 4H20.5C21.0523 4 21.5 4.44771 21.5 5V15.4667C21.5 16.019 21.0523 16.4667 20.5 16.4667H8.9448C8.69862 16.4667 8.46109 16.5575 8.2777 16.7217L5.1671 19.5072C4.52301 20.0839 3.5 19.6268 3.5 18.7622Z",
  fill: "currentColor",
  stroke: "currentColor",
  "stroke-width": "1.5",
  "stroke-linecap": "round"
}, null, -1)
const _hoisted_4 = ["width", "height"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("rect", {
  width: "24",
  height: "24",
  transform: "translate(0.5)"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("path", {
  d: "M3.5 18.7622V5C3.5 4.44772 3.94772 4 4.5 4H20.5C21.0523 4 21.5 4.44771 21.5 5V15.4667C21.5 16.019 21.0523 16.4667 20.5 16.4667H8.9448C8.69862 16.4667 8.46109 16.5575 8.2777 16.7217L5.1671 19.5072C4.52301 20.0839 3.5 19.6268 3.5 18.7622Z",
  stroke: "currentColor",
  "stroke-width": "1.5",
  "stroke-linecap": "round"
}, null, -1)


export default /*#__PURE__*/_defineComponent({
  __name: 'MessageSquareIcon',
  props: {
  width: {
    type: Number,
    default: 26
  },
  height: {
    type: Number,
    default: 26
  },
  wrapperClass: {
    type: String,
    default: ""
  },
  checked: {
    type: Boolean,
    default: false
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (__props.checked)
    ? (_openBlock(), _createElementBlock("svg", {
        key: 0,
        width: __props.width,
        height: __props.height,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        class: _normalizeClass(__props.wrapperClass)
      }, [
        _hoisted_2,
        _createTextVNode(),
        _hoisted_3
      ], 10, _hoisted_1))
    : (_openBlock(), _createElementBlock("svg", {
        key: 1,
        width: __props.width,
        height: __props.height,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        class: _normalizeClass(__props.wrapperClass)
      }, [
        _hoisted_5,
        _createTextVNode(),
        _hoisted_6
      ], 10, _hoisted_4))
}
}

})